import React, { Component } from "react";
import styled from "styled-components";

export default class BlueButton extends Component {


   render() {
      //  console.log(this.props);

      const BlueButton = styled.button`
width: 9.38rem;
height: 2.5rem;
background-color: rgba(0, 164, 229, 1);
transition: background-color 0.3s ease 0s;
color: rgb(255,255,255);
text-transform: uppercase;
font-weight:700;
:hover{
   background-color: rgb(0, 116, 162);
};
@media (max-width:29rem) {
   width: ${(props) => (this.props.width ? '100%' : '9.38rem')};
}
      `

      return (
         <BlueButton>
            {this.props.text}
         </BlueButton>
      )
   }
}